/* eslint-disable no-return-assign */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import * as actions from "actions";
import Section from "components/Section";
import InputMask from 'react-input-mask'
import ProductCarousel from "components/product";
import ServiceHeader from "components/ServiceHeader";
import ServiceBottom from "components/ServiceBottom";
import Layout from "layout/Layout";
import IntlMessages from "util/IntlMessages";
import CardBox from "components/CardBox/index";
import { Field, reduxForm, formValueSelector, initialize } from "redux-form";
import { Button, Spinner,Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReactDOM from "react-dom";
import DragAndDown from "components/DragAndDropImage";
import CircularProgress from "components/CircularProgress";
import DayPickerInput from "react-day-picker/DayPickerInput";
import moment from "moment";
import { YearMonthForm, fromMonth, toMonth } from "./YearMonthForm";
import normalizePhone from "../util/normalizePhone";
import { phoneMask } from '../util/consts'
import CustomerForm from "../components/adminForms/CustomerForm";
import axios from "services/customer";
import { NotificationContainer, NotificationManager } from "react-notifications";
import AppLocale from "lngProvider";
class CustomerProfile extends Component {
  state = {
    month: fromMonth,
    accepted: [],
    rejected: [],
    gallerymodal:false,
      itemToDelete:[]
  };
  handleYearMonthChange = month => {
    this.setState({ month });
  };

  componentDidMount() {
    ReactDOM.findDOMNode(this).scrollIntoView();
    // this.props.fillCustomerProfileDetails();
  }
  handleRequestClose = () => {
    this.props.handleRequestCloseSetting();
  };
  componentDidUpdate() {
    this.props.changePageTitle(`Profile | Vibo Vibo`);
  }
  // componentWillMount(){
  //   // this.props.requestCustomerData();
  // }
  // // handleSubmit = formValues => {
  // //   formValues.preventDefault();
  // //   const {
  // //     imageFile,
  // //     dateOfBirth,
  // //     customerDetails
  // //   } = this.props;

  //   formValues.checkEmail = customerDetails.email;

  //   this.props.customerOnShowLoader();
  //   // this.props.changeCustomerProfile({
  //   //   formValues,
  //   //   imageFile,
  //   //   date_of_birth: moment(dateOfBirth).format("YYYY-MM-DD")
  //   // });
  // };
  onDrop = (accepted, rejected) => {
    this.props.setCustomerProfileImageFile(accepted[0]);
    this.setState({ accepted, rejected });
  };

  renderDragAndDrop = ({
    input,
    className,
    name,
    classType,
    labelName,
    colName,
    onDrop,
    imageName,
    handleRemove,
    imageid,
    meta: { touched, error, warning }
  }) => (
      <div className={`${colName} col-12`}>
        <div className={`form-group ${classType}`}>
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
          </label>
          <DragAndDown
            onDrop={onDrop}
            name={name}
            id={name}
            {...input}
            imageName={imageName}
            handleRemove={handleRemove}
            imageid={imageid}
          />
          {imageName ? imageName.name : null}
          {/* {touched && (error && <span className="error-message">{error}</span>)} */}
        </div>
      </div>
    );

  renderPhoneInput = ({
    input,
    placeholder,
    name,
    className,
    type,
    classType,
    height,
    labelName,
    colName,
    required,
    meta: { touched, error },
  }) => (
      <div className={`${colName} col-12`}>
        <div className={`form-group ${classType}`}>
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
            {required ? <span className="text-danger">*</span> : null}
          </label>
          <InputMask
            {...input}
            alwaysShowMask={false}
            mask={phoneMask}
            style={{ height }}
            className={className}
            id={name}
            name={name}
            placeholder={placeholder}
            type={type}
          />
          {touched &&
            (error && (
              <span className="error-message">
                <IntlMessages id={error} />
              </span>
            ))}
        </div>
      </div>
    )

  renderInput = ({
    input,
    placeholder,
    name,
    className,
    type,
    classType,
    height,
    labelName,
    colName,
    required,
    meta: { touched, error, warning }
  }) => (
      <div className={`${colName} col-12`}>
        <div className={`form-group ${classType}`}>
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
            {required ? <span className="text-danger">*</span> : null}
          </label>
          <input
            {...input}
            style={{ height }}
            className={className}
            id={name}
            name={name}
            {...input}
            placeholder={placeholder}
            type={type}
            autoComplete="new-password"
          />
          {touched &&
            (error && (
              <span className="error-message">
                <IntlMessages id={error} />
              </span>
            ))}
        </div>
      </div>
    );

  renderTextArea = ({
    input,
    placeholder,
    name,
    labelName,
    type,
    required,
    meta: { touched, error, warning }
  }) => (
      <div className="col-12">
        <div className="form-group">
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
            {required ? <span className="text-danger">*</span> : null}
          </label>
          <textarea
            {...input}
            className="form-control form-control-lg"
            placeholder={placeholder}
            rows="6"
            type={type}
            name={name}
            autoComplete="new-email"
          />
          {touched &&
            (error && (
              <span className="error-message">
                <IntlMessages id={error} />
              </span>
            ))}
        </div>
      </div>
    );

  renderSelectCustomer = ({
    input,
    name,
    className,
    meta: { touched, error, warning },
    arrayName,
    labelName,
    disabled,
    required
  }) => (
      <div className="col-md-6 col-12">
        <div className="form-group">
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
            {required ? <span className="text-danger">*</span> : null}
          </label>
          <select
            {...input}
            className={className}
            name={name}
            disabled={disabled}
          >
            <option value="male">
              Male
            {/* <IntlMessages id="customer.form.male" /> */}
            </option>
            <option value="female">
              Female
            {/* <IntlMessages id="customer.form.female" /> */}
            </option>
          </select>
          {touched &&
            (error && (
              <span className="error-message">
                <IntlMessages id={error} />
              </span>
            ))}
        </div>
      </div>
    );

  onSubmit = formValues => {
   const {imageid}=this.props;
    formValues.checkEmail = this.props.initialValues.email;
    this.props.changeCustomerProfileSet();
    this.props.customerOnShowLoader();
    this.props.changeCustomerProfile({
      formValues,
      imageFile: this.props.imageFile,
      date_of_birth: moment(this.props.dob).format("YYYY-MM-DD"),
      editCustomerState: true,
      addCustomerState: false,
      imageid
    });
  };

  handleDateOfBirth = value => {
    this.props.handleDateOfBirthCustomer(value);
  };

  customerClearFormData = () => { };

  modalToggle = () => {
    this.setState({ gallerymodal:false });
  };
  showDeleteConfirmationModalGallery = item => {
    this.setState({ gallerymodal: true,itemToDelete:item });
  }
  handleImageRemove = currentImg => {
    console.log("DELETE IMAGE", currentImg);
    const id=currentImg._id;
    let delteData={
      from:"userProfile",
      id:id
    }
    this.props.deleteGalleryImage(delteData);
    this.modalToggle();
  };
  render() {
    
    const currentAppLocale = AppLocale[this.props.locale.locale];
    console.log("ALERT MESSAGE",this.props.alertMessage);
    const closeBtn = (
      <button className="close" onClick={this.modalToggle}>
        &times;
      </button>
    );
    (function () {
      const token = localStorage.getItem("token");
      if (token) {
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      } else {
        axios.defaults.headers.common.Authorization = null;
        /* if setting null does not remove `Authorization` header then try
            delete axios.defaults.headers.common['Authorization'];
          */
      }
    })();
    const submitButton = this.props.loader ? (
      <CircularProgress />
    ) : (
        <Button className="btn btn-vibo2" size="md" type="submit">
          <IntlMessages id="vibo.customer.form.submit" />
        </Button>
      );

    const bottom = true ? (
      <div className="text-right w-100">
        <Button
          className="btn btn-light"
          size="md"
          onClick={() => {
            // customerClearFormData();
            // changeCustomerAdminDisplay(1);
            this.props.history.push("/");
          }}
        >
          <IntlMessages id="vibo.customer.form.cancel" />
        </Button>
        {submitButton}
      </div>
    ) : null;
    return (
      <Layout>
        <Helmet>
          <title>{this.props.pageTitle}</title>
        </Helmet>
        <div className="row employee-form form-mycss" style={{ paddingBottom: "35px", margin: '50px' }}>
        <div>
        <Modal isOpen={this.state.gallerymodal} >
          <ModalHeader toggle={this.modalToggle} close={closeBtn}>
            <IntlMessages id="vibo.deleteConfirmation.gallery.modal.header" />
          </ModalHeader>
          <ModalBody className="">
            <IntlMessages id="vibo.deleteConfirmation.gallery.modal.body" />
          </ModalBody>
          <ModalFooter>
            <React.Fragment>
              <Button
                size="md"
                className="btn btn-light"
                onClick={() => {
                  this.modalToggle();
                }}
              >
                <IntlMessages id="vibo.deleteConfirmation.gallery.modal.no" />
              </Button>
              <Button
                className="btn btn-vibo2"
                size="md"
                onClick={() => {
                  this.handleImageRemove(this.state.itemToDelete);
                }}
              >
                <IntlMessages id="vibo.deleteConfirmation.gallery.modal.yes" />
              </Button>
            </React.Fragment>
          </ModalFooter>
        </Modal>
      </div>
          <div className="col-12">
            <h1 className="col-12">My Account</h1>
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
              <div className="row">
                <Field
                  name="firstname"
                  component={this.renderInput}
                  placeholder="John"
                  type="text"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.firstname"
                  required
                />
                <Field
                  name="lastname"
                  component={this.renderInput}
                  placeholder="Doe"
                  type="text"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.lastname"
                  required
                />
              </div>
              <div className="row">
                <Field
                  name="email"
                  component={this.renderInput}
                  placeholder="johndoe@gmail.com"
                  type="email"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.email"
                  required
                />
                {/* <Field
                  name="phonenumber"
                  component={this.renderInput}
                  placeholder="+1 (111) 222-4444"
                  type="tel"
                  normalize={normalizePhone}
                  className="form-control form-control-md"
                  classType=""
                  height="35px"
                  colName="col-md-6"
                  labelName="vibo.customer.form.phoneNumber"
                /> */}
                <Field
                  name='phonenumber'
                  component={this.renderPhoneInput}
                  placeholder="+1 (000) 000-0000"
                  type="text"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.employees.form.phoneNumber"
                  required
                />
                {/* <div class="col-md-6 col-12">
                  <div class="form-group ">
                    <label><span><IntlMessages id="vibo.customer.form.phoneNumber" /></span><span class="text-danger">*</span></label>
                    <NumberFormat placeholder="+1 (111) 222-4444" className="form-control form-control-md" style={{height:"35px"}} name="phonenumber" format="+1 (###) ### ####" mask="_" />
                  </div>
                </div>               */}
              </div>

              <div className="row ">
                <Field
                  name="address1"
                  component={this.renderInput}
                  placeholder="Address line 1"
                  type="text"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.address1"
                />
                <Field
                  name="address2"
                  component={this.renderInput}
                  placeholder="Address line 2"
                  type="text"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.address2"
                />
              </div>
              <div className="row ">
                <Field
                  name="city"
                  component={this.renderInput}
                  placeholder="City"
                  type="text"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.city"
                />
                <Field
                  name="stateId"
                  component={this.renderInput}
                  placeholder="State"
                  type="text"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.state"
                />
              </div>
              <div className="row">
                <Field
                  name="country"
                  component={this.renderInput}
                  placeholder="Country"
                  type="text"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.country"
                />
                <Field
                  name="zipcode"
                  component={this.renderInput}
                  placeholder="Zipcode"
                  type="number"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.zipcode"
                />
              </div>
              <div className="row ">
                <Field
                  name="gender"
                  component={this.renderSelectCustomer}
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.gender"
                />
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label>
                      <IntlMessages id="vibo.customer.form.dateOfBirth" />
                    </label>
                    <DayPickerInput
                      value={moment(this.props.initialValues.dob).format(
                        "YYYY-MM-DD"
                      )}
                      onDayChange={this.handleDateOfBirth}
                      dayPickerProps={{
                        selectedDays: [this.props.initialValues.dob],
                        month: this.state.month,
                        fromMonth,
                        toMonth,
                        captionElement: ({ date, localeUtils }) => (
                          <YearMonthForm
                            date={date}
                            localeUtils={localeUtils}
                            onChange={this.handleYearMonthChange}
                          />
                        )
                        // modifiers: {
                        //   disabled: [{ after: new Date(1950, 1, 1) }],
                        // },
                      }}
                      placeholder="Select Date Of Birth"
                      name="customerDateOfBirth"
                      colName="col-md-6"
                      keepFocus={false}
                      inputProps={{ readOnly: true }}
                    />
                  </div>
                </div>
              </div>
              <div className="row" />
              <div className="row">
                <Field
                  name="newPassword"
                  component={this.renderInput}
                  placeholder="New Password"
                  type="password"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.businessProfile.owner.newPassword"
                />
                <Field
                  name="confirmPassword"
                  component={this.renderInput}
                  placeholder="Confirm Password"
                  type="password"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.businessProfile.owner.confirmPassword"
                />
              </div>
              <div className="row">
                <Field
                  name="specialRequests"
                  component={this.renderTextArea}
                  placeholder="Special Requests (optional)"
                  type="textArea"
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.businessProfile.owner.specialRequests"
                />
              </div>
              <div className="row">
                <Field
                  name="filedrop"
                  component={this.renderDragAndDrop}
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.photo"
                  onDrop={this.onDrop}
                  imageName={this.props.imageFile}
                  imageid={this.props.imageid}
                  handleRemove={()=>this.showDeleteConfirmationModalGallery(this.props.imageFile)}
                />
              </div>

              {bottom}
            </form>
          </div>
        </div>
        {/* {this.props.showMessage &&
          NotificationManager.success(
            currentAppLocale.messages[this.props.alertMessage],
            this.handleRequestClose()
          )}
        {this.props.errorMessage &&
          NotificationManager.error(this.props.alertMessage, this.handleRequestClose())}
        <NotificationContainer /> */}
      </Layout>
    );
  }
}

const validate = formValues => {
  const errors = {};
  if (!formValues.firstname) {
    errors.firstname = "vibo.error.form.firstname";
  }
  // if (!formValues.address1) {
  //   errors.address1 = "You must enter Address 1";
  // }
  // if (!formValues.city) {
  //   errors.city = "You must enter City";
  // }
  // if (!formValues.stateId) {
  //   errors.stateId = "You must enter State";
  // }
  // if (!formValues.zipcode) {
  //   errors.zipcode = "You must enter Zipcode";
  // } else if (formValues.zipcode.length !== 5) {
  //   errors.zipcode = "You must enter valid zipcode ";
  // }
  // if (!formValues.gender) {
  //   errors.gender = "vibo.error.form.gender";
  // }
  // if (!formValues.country) {
  //   errors.country = "You must Enter Country";
  // }
  if (!formValues.lastname) {
    errors.lastname = "vibo.error.form.lastname";
  }
  if (formValues.zipcode && !/^[0-9]+/g.test(formValues.zipcode)) {
    errors.zipcode = "vibo.error.form.zipcode";
  } else if (formValues.zipcode && formValues.zipcode.length !== 5) {
    errors.zipcode = "vibo.error.form.validZipcode";
  }

  if (!formValues.email) {
    errors.email = "vibo.error.form.email";
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues.email)
  ) {
    errors.email = "vibo.error.form.validEmail";
  }
  if (
    formValues.phonenumber &&
    !/^([+]{1})([1]{1})([0-9]{3})([0-9]{3})([0-9]{4})$/g.test(
      "+" + formValues.phonenumber.replace(/[^\d]/g, "")
    )
  ) {
    errors.phonenumber = "vibo.error.form.validPhoneNumber";
  }
  if (
    !/^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*]{8,}$/.test(
      formValues.newPassword
    ) &&
    formValues.newPassword.length !== 0
  ) {
    errors.newPassword = "vibo.error.form.password";
  } else if (formValues.newPassword !== formValues.confirmPassword) {
    errors.newPassword = "vibo.error.form.passwordNotEqual";
    errors.confirmPassword = "vibo.error.form.passwordNotEqual";
  }

  return errors;
};

const selector = formValueSelector("CustomerProfile");

CustomerProfile = reduxForm({
  form: "CustomerProfile",
  validate,
  touchOnChange: true,
  enableReinitialize: true
  // config: true,
})(CustomerProfile);

const mapStateToProps = ({
  customerAdmin,
  changeTitle,
  customerBooking,
  customerProfile,
  settings
}) => ({
  initialValues: customerProfile.customerProfile,
  imageFile: customerProfile.imageFile,
  dob: customerProfile.dob,
  imageid:customerProfile.imageid,
  loader: customerAdmin.customerLoader,
  pageTitle: changeTitle.pageTitle,
  // closureLoader: customerAdmin.closureLoader,
  // errorMessage: customerAdmin.errorMessage,
  showMessage: customerProfile.showMessage,
  alertMessage: customerProfile.alertMessage,
  locale:settings.locale,
  // customerDetails:customerAdmin.customerDetails,
  // dateOfBirth:customerAdmin.dateOfBirth
});
const mapDispatchToProps = dispatch => ({
  changePageTitle: payload => dispatch(actions.setTitleOfPage(payload)),
  customerOnShowLoader: () => dispatch(actions.customerOnShowLoader()),
  submitNewCustomerAdmin: payload =>
    dispatch(actions.submitNewCustomerAdmin(payload)),
  changeCustomerProfile: payload =>
    dispatch(actions.changeCustomerProfile(payload)),
  requestCustomerData: () => dispatch(actions.requestCustomerData()),
  fillCustomerProfileDetails: () =>
    dispatch(actions.fillCustomerProfileDetails()),
  handleDateOfBirthCustomer: payload =>
    dispatch(actions.handleDateOfBirthCustomer(payload)),
  setCustomerProfileImageFile: payload =>
    dispatch(actions.setCustomerProfileImageFile(payload)),
    handleRequestCloseSetting: () => dispatch(actions.handleRequestCloseSetting()),
    changeCustomerProfileSet : () => dispatch(actions.changeCustomerProfileSet()),
    deleteGalleryImage : payload => dispatch(actions.deleteGalleryImage(payload))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CustomerProfile)
);



// WEBPACK FOOTER //
// ./containers/CustomerProfile.js